// extracted by mini-css-extract-plugin
export var no_hits = "NoHits-module--no_hits--CmaJK";